// This file is generated automatically by scripts/generate-flag.js. Don't modify it.
import React from 'react';
import Egypt from '../_raw/flag/icon_flag_egypt.png';

export default () => <img src={Egypt} alt="Egypt" />;
